interface TechBadgeProps {
    name: string;
    size?: 'sm' | 'md';
}

export function TechBadge({ name, size = 'md' }: TechBadgeProps) {
    const sizeClasses = size === 'sm'
        ? 'text-xs px-2 py-0.5'
        : 'text-sm px-3 py-1';

    return (
        <span className={`inline-flex items-center rounded-full font-medium ${sizeClasses} bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-700/10 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/30 hover:bg-blue-100 dark:hover:bg-blue-400/20 transition-colors`}>
            {name}
        </span>
    );
}
